import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService } from 'src/app/services/device/device.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { HistoryManager } from 'src/app/services/history-manager/history-manager.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common/common.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';

@Component({
	selector: 'vtr-header-main',
	templateUrl: './header-main.component.html',
	styleUrls: [
		'./header-main.component.scss'
	]
})
export class HeaderMainComponent implements OnInit, AfterViewInit, OnChanges {
	subscription: Subscription;

	faChevronLeft = faChevronLeft;

	@Input() title = ' ';
	@Input() back: string;
	@Input() backarrow = '<';
	@Input() forwardLink: { path: string, label: string };
	@Input() menuItems: any[];
	@Input() parentPath: string;
	@Input() backId: string;
	@Input() ariaLabel: string;
	@Input() isInnerBack = false;
	@Input() textId: string;
	@Input() hideBack = false;
	@Output() innerBack = new EventEmitter();
	@Input() hideTitle = false;

	constructor(
		private router: Router,
		public deviceService: DeviceService,
		private configService: ConfigService,
		private historyManager: HistoryManager,
		private commonService: CommonService
	) {
		this.subscription = this.commonService.notification.subscribe((notification: AppNotification) => {
			this.onNotification(notification);
		});
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case 'routerChanged':
					this.checkBackButton();
					break;
				default:
					break;
			}
		}
	}

	ngOnChanges() {
		this.checkBackButton();
	}

	ngOnInit() {
		this.checkBackButton();
		const self = this;
		if (this.parentPath !== '' && this.parentPath !== undefined) {
			this.menuItems.forEach((d, i) => {
				d.path = self.parentPath + '/' + d.path;
			});
		}
	}

	ngAfterViewInit() {
		const back = document.getElementById(this.backId);
		if (back) {
			back.addEventListener('focus', () => {
				window.scrollTo(0, 0);
			});
		}
	}

	onInnerBack() {
		this.innerBack.emit();
	}

	goBack($event: any) {
		$event.preventDefault();
		$event.stopPropagation();

		if (this.isInnerBack) {
			this.onInnerBack();
		} else {
			this.historyManager.goBack();
		}
	}

	checkBackButton() {
		if (this.menuItems && this.menuItems.length > 0 && this.menuItems[0].outlets) {
			this.hideBack = this.router.url === this.router.createUrlTree([this.configService.defaultRoute.toString(), {outlets: this.menuItems[0].outlets}]).toString();
		} else {
			if (!this.hideBack) {
				this.hideBack = this.router.url === this.configService.defaultRoute.toString();
			}
		}
	}
}
